import '@/assets/css/crefo-ui.min.css'

import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import i18n from '@/i18n'
import { createPinia } from 'pinia'
import DataReady from '@/plugins/data-ready'
import CrefoUI from '@/plugins/crefo-ui'
import Webtrekk from '@/plugins/webtrekk'
import Autocomplete from 'v-autocomplete'

export function initApp() {
    const app = createApp(App)
    const pinia = createPinia()
    console.log('')
    app.config.productionTip = false
    app.use(DataReady)
    app.use(CrefoUI)
    app.use(Webtrekk)
    app.use(Autocomplete)
    app.use(i18n)
    app.use(router)
    app.use(pinia)
    app.mount('#app')

    return app
}

initApp()
